import intlTelInput from 'intl-tel-input';
import {GetSlugAndParamsFromNext} from '../utilities'

export const input = document.querySelector("#phone");

// const button = document.querySelector("#btn");
const validMsg = document.querySelector("#check-phone-success");
const errorMsg = document.querySelector("#check-phone-error");

// here, the index maps to the error code returned from getValidationError - see readme
const errorMap = ["ensure the number is valid", "invalid country code", "incomplete number", "too long, did you type 0 at the beginning? remove the 0 or choose the right country from the list", "ensure the number is valid"];


// Get Selected Country Data initial value

export let SelectedPhoneCountry
export let PhoneInputValue
export let iti

// Reset phone validation error message
const resetPhoneInputValidationErrors = () => {
  input.classList.remove("error");
  errorMsg.innerHTML = "";
  errorMsg.classList.remove("flex");
  validMsg.classList.remove("flex");
  errorMsg.classList.add("hidden");
  validMsg.classList.add("hidden");
};

// typeof input is "object", but input is null if not found
// SelectedPhoneCountry above is undefined so typeof SelectedPhoneCountry is "undefined" 
// Due to type coercion, undefined == null is true but undefined === null is false
// So if input is null, then initialize to avoid errors
if (input !== null) {

  iti = intlTelInput(input, {
      // Show on top
      preferredCountries: ["us", "ca", "gb", "de", "gh", "ke", "za", "ng", "in", "il", "ps"],
      utilsScript: "/static-assets/js/utils.js"
      // Use /static-assets/ it will be resolved at runtime by fiber static server
      // utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js"
  });

  SelectedPhoneCountry = iti.getSelectedCountryData().iso2;

  // listen to the telephone input for changes
  input.addEventListener('countrychange', () => {
    SelectedPhoneCountry = iti.getSelectedCountryData().iso2;

    // Send tracking event
    SubmitTrackedPhoneEventInfo("user_phone_country: " + SelectedPhoneCountry, "signup")
  });

  // on keyup / change flag: reset
  input.addEventListener('focusout', ValidatePhoneInput);

  input.addEventListener('change', ()=>{
    resetPhoneInputValidationErrors();

    // Get phone value
    let phoneValue = input.value.trim()
    // Send tracking event

    // Set global phone value
    PhoneInputValue = phoneValue

    // Let's know when user enters phone number
    SubmitTrackedPhoneLeadEvent("user_phone_entered: " + phoneValue, "signup")
  });

  input.addEventListener('keyup', resetPhoneInputValidationErrors);
 
}


// Will be called on form submit
export default function ValidatePhoneInput() {
    let isPossiblePhone = true
    resetPhoneInputValidationErrors();
    // If phone number is not empty
    PhoneInputValue = input.value.trim()
    if (PhoneInputValue) {
      if (iti.isPossibleNumber()) {
        isPossiblePhone = true
        validMsg.classList.add("flex");
        validMsg.classList.remove("hidden");
      } else {
        isPossiblePhone = false
        input.classList.add("error");
        let errorCode = iti.getValidationError();
        if ((errorCode === -99)) {
          // Many are facing challenges with outdated browsers
          // Maybe this will help
          isPossiblePhone = true
          return isPossiblePhone
          // errorCode = (errorCode === -99)? 0 : errorCode
        }
        console.log("phone validation error code", errorCode)
        errorMsg.innerHTML = errorMap[errorCode];
        errorMsg.classList.add("flex");
        errorMsg.classList.remove("hidden");

      }
    }
    return isPossiblePhone
}


// export default input

// Track Phone Lead Event
async function SubmitTrackedPhoneLeadEvent(eventDescription, page) {

    let targetInfo = eventDescription;

    // let currentPage = page;
    let currentPage = GetSlugAndParamsFromNext().srcPage
    if(currentPage == null) {
      currentPage = page
    }

    let eventHandle = "auth event from: "
       
    // Already tracked, send the update event to backend
    if(window.TrackedLeadEvent) {
      eventHandle = "lead update event from: "
      console.log("lead event already tracked sending lead update")
        
    } else if ((window.TEmailAddress != "" || window.TPhoneNumber != "")) {
      window.TrackedLeadEvent = true
      eventHandle = "lead event from: "
      console.log("lead event condition met, sending lead track")
    }

    return fetch('/page/trackleads/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({
          event: eventHandle +" "+ currentPage +" page", 
          page: currentPage, 
          target: targetInfo,
          country: SelectedPhoneCountry,
          name: window.TFullName,
          phone: PhoneInputValue,
          email: window.TEmailAddress,
        }),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}

// Track Phone Event Info
async function SubmitTrackedPhoneEventInfo(eventDescription, page) {

    let targetInfo = eventDescription;

    let currentPage = page;

    return fetch('/page/trackevents/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({
          event: "auth event from: " + currentPage +" page", 
          target: targetInfo,
          page: currentPage
        }),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}